module.exports = __webpack_public_path__ + "img/icon-image.ac4e266c.svg";